/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiPushedMetaEventType;
(function (ApiPushedMetaEventType) {
    ApiPushedMetaEventType["PUSHED_META_EVENT_TYP_CONVERSION"] = "PushedMetaEventTypConversion";
    ApiPushedMetaEventType["PUSHED_META_EVENT_TYPE_EFFECTIVE_VISIT"] = "PushedMetaEventTypeEffectiveVisit";
    ApiPushedMetaEventType["PUSHED_META_EVENT_TYPE_EFFECTIVE_PAGEVIEW"] = "PushedMetaEventTypeEffectivePageview";
})(ApiPushedMetaEventType || (ApiPushedMetaEventType = {}));
export function ApiPushedMetaEventTypeFromJSON(json) {
    return ApiPushedMetaEventTypeFromJSONTyped(json, false);
}
export function ApiPushedMetaEventTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiPushedMetaEventTypeToJSON(value) {
    return value;
}
